import React from "react";
import cc from "currency-codes";

class StatisticsGrid extends React.Component {
	constructor(props) {
		super(props);
	}

	splitByCurrency = (commissions) => {
		if (typeof commissions !== "object" || commissions === null) return null;

		return Object.entries(commissions).map(([key, value], index) => {
			const amount = value.toFixed(2);
			return (
				<h4 key={index}>
					{cc.number(key).code} ${amount}
				</h4>
			);
		});
	};

	render() {
		const { monthCommissionTotal, monthTransactionsTotal, titlePrefix } =
			this.props;
		return (
			<div className="uk-margin-bottom uk-child-width-expand uk-grid">
				<div>
					<div className="statistics-box uk-background-primary uk-card uk-card-default uk-card-body">
						<div className="uk-grid">
							<div className="uk-width-auto commission-icon-container">
								<i
									className="commission-icon"
									uk-icon={`icon: fa-solid-money-check-alt; ratio: 2`}
								/>
							</div>
							<div className="uk-width-expand">
								<div className="commission-statistics-text">
									<h4>{titlePrefix || "Total"} Commissions</h4>
									{this.splitByCurrency(monthCommissionTotal)}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div className="statistics-box uk-background-secondary uk-card uk-card-default uk-card-body">
						<div className="uk-grid">
							<div className="uk-width-auto commission-icon-container">
								<i
									className="commission-icon"
									uk-icon={`icon: fa-solid-file-invoice-dollar; ratio: 2`}
								/>
							</div>
							<div className="uk-width-expand">
								<div className="commission-statistics-text">
									<h4>{titlePrefix || "Total"} Transactions</h4>
									<h4>{monthTransactionsTotal}</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default StatisticsGrid;
